let channels = process.env.WC_LOG_CHANNELS ? process.env.WC_LOG_CHANNELS.split(',') : [];

type Logger = {
  error: (...args: any[]) => void;
  warn: (...args: any[]) => void;
  trace: (...args: any[]) => void;
  [key: string]: (...args: any[]) => void;
};

const baseLogger = {
  error: console.error,
  warn: console.warn,
  trace: console.trace,
} as any;

const logger: Logger = new Proxy(baseLogger, {
  get: (target, prop, receiver) => {
    if (typeof target[prop] === 'function') {
      return target[prop].bind(target);
    }
    return () => {};
  },
});

export function enable_channels(channels: string[]) {
  channels.forEach((channel) => {
    if (typeof baseLogger[channel] !== 'function') {
      baseLogger[channel] = console.log;
    }
  });
}

enable_channels(channels.map((e) => e.trim()));

export default logger;
